// extracted by mini-css-extract-plugin
export default {"cardHeader":"ordercreate_cardHeader__z1UkP","myCardBlock":"ordercreate_myCardBlock__kCA95"};